import { store } from '@/store';
import Worker from '@/utils/timer.worker';
import auth from '@/utils/auth';

const idle = {
    timeout: process.env.VUE_APP_IDLE_TIMEOUT, // 到期秒數，預設 1800
    promptTimeout: process.env.VUE_APP_IDLE_PROMPT_TIMEOUT, // 跳出提示視窗秒數，預設 1680
    worker: null,
    /**
     * 清除資料
     */
    clear() {
        if (idle.worker) {
            idle.worker.terminate();
            idle.worker = null;
            store.commit('idle/clearAllTimeout');
            store.commit('idle/hidePrompt');
        }
    },
    /**
     * 重設閒置計算時間
     */
    reset() {
        idle.clear();
        idle.countdown();
    },
    /**
     * 閒置提醒倒數計時
     */
    countdown() {
        // loop event
        this.worker = new Worker();
        this.worker.postMessage(this.timeout);
        this.worker.onmessage = (event) => {
            if (event.data >= this.timeout - this.promptTimeout)
                store.commit(
                    'idle/setIdleTimeout',
                    event.data - (this.timeout - this.promptTimeout)
                );
            store.commit('idle/setTimeout', event.data);

            if (event.data < 1) {
                this.stop();
                auth.logout();

                setTimeout(() => {
                    store.commit('closeLoading');
                    store.commit('setDialog', {
                        type: 'remind',
                        title: '溫馨提醒',
                        text: `您好，因網頁閒置已逾${auth.idleTimeout}分鐘未進行任何操作，基於資訊安全的考量。請按下確認後回到首頁，謝謝。`,
                        active: true,
                    });
                }, 500);
            } else if (
                event.data < this.timeout - this.promptTimeout &&
                !store.state.idle.isPrompted
            ) {
                window.removeEventListener('mousemove', idle.reset);
                window.removeEventListener('touchstart', idle.reset);
                store.commit('idle/showPrompt', {
                    timeout: this.timeout,
                    promptTimeout: this.promptTimeout,
                });
            }
        };
    },
    /**
     * 開始計算時間
     */
    start() {
        idle.clear();
        window.addEventListener('mousemove', idle.reset);
        window.addEventListener('touchstart', idle.reset);
        this.countdown();
    },
    /**
     * 停止計算時間
     * @returns
     */
    stop() {
        this.clear();
        window.removeEventListener('mousemove', idle.reset);
        window.removeEventListener('touchstart', idle.reset);
        return true;
    },
};

export default idle;
